<template>
  <div class="text--center">
    <sib-button
      class="product-button-write-review"
      size="md"
      @click="hanldeClick"
    >
      Write your review
    </sib-button>
  </div>
</template>
<script setup lang="ts">
import EventBus from '@/services/eventbus'
import { EVENT_CLICK_PRODUCT_FORM_REVIEW_BUTTON } from '@/utils'

function hanldeClick() {
  EventBus.trigger(EVENT_CLICK_PRODUCT_FORM_REVIEW_BUTTON)
}
</script>
